import { InputNumber, Text, IconButton, InputSizes, TextAs, TextSizes } from '@clockout-dev/design-elements';
import { DeleteOutlined } from '@ant-design/icons';
import styles from '../styles/limitsForm.module.scss';

function VolumeAdvancedCapTenureRuleRow({ rule, onUpdate, onRemove, disabled }) {
    return (
        <div className={styles.ruleRow}>
            <Text as="span" size="s" className={styles.ruleLabel}>
                if a user has a tenure of
            </Text>
            <InputNumber
                size={InputSizes.SMALL}
                key={`fromDays-${rule.id}`}
                defaultValue={rule.fromDays}
                onChange={(value) => onUpdate(rule.id, 'fromDays', value)}
                min={0}
                max={36500}
                controls={false}
                disabled={disabled}
                placeholder="From"
                className={`${styles.inlineNumberInput} ${styles.rangeField}`}
            />
            <Text as="span" size="s" className={styles.ruleLabel}>
                to
            </Text>
            <InputNumber
                size={InputSizes.SMALL}
                key={`toDays-${rule.id}`}
                defaultValue={rule.toDays}
                onChange={(value) => onUpdate(rule.id, 'toDays', value)}
                min={0}
                max={36500}
                controls={false}
                disabled={disabled}
                placeholder="To"
                className={`${styles.inlineNumberInput} ${styles.rangeField}`}
            />
            <Text as="span" size="s" className={styles.ruleLabel}>
                days, their volume cap will be exactly
            </Text>
            <InputNumber
                size={InputSizes.SMALL}
                key={`value-${rule.id}`}
                defaultValue={rule.value}
                onChange={(value) => onUpdate(rule.id, 'value', value)}
                min={0}
                max={999999.99}
                step={0.01}
                precision={2}
                prefix={<Text as={TextAs.SPAN} size={TextSizes.SMALL}>$</Text>}
                controls={false}
                disabled={disabled}
                className={`${styles.inlineNumberInput} ${styles.amountField}`}
            />
            <IconButton
                type="button"
                icon={<DeleteOutlined />}
                aria-label="Remove row"
                onClick={() => onRemove(rule.id)}
                disabled={disabled}
            />
        </div>
    );
}

export default VolumeAdvancedCapTenureRuleRow;
